import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { createCommission } from 'bundles/apex/deals/show/store/deal/actions';

import { Button } from 'components/ui/button';
import BrokerInput from './broker_input';
import Modal from 'components/modal';
import TransactionSideInput from './transaction_side_input';

export function InternalBrokerModal({ createCommission, transactionSide, onHide, show }) {
  const [broker, setBroker] = useState();
  const [formTransactionSide, setTransactionSide] = useState(transactionSide);
  const [saving, setSaving] = useState();

  async function handleSave() {
    setSaving(true);
    await createCommission({ broker, outside: false, transactionSide: formTransactionSide });
    onHide();
    setSaving(false);
  }

  function reset() {
    setBroker(null);
    setTransactionSide(transactionSide);
  }

  return (
    <Modal show={show} onHide={onHide} onShow={reset}>
      <Modal.Header closeButton>
        Add Internal Broker
      </Modal.Header>

      <Modal.Body>
        <div>
          <BrokerInput broker={broker} transactionSide={transactionSide} onChange={setBroker}/>
          {transactionSide === undefined &&
            <TransactionSideInput transactionSide={formTransactionSide} onChange={setTransactionSide} />
          }
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onHide} />
        <Button disabled={!broker || saving} label="Add Broker" onClick={handleSave} />
      </Modal.Footer>

    </Modal>
  );
}

InternalBrokerModal.propTypes = {
  createCommission: PropTypes.func.isRequired,
  show: PropTypes.bool,
  transactionSide: PropTypes.string,
  onHide: PropTypes.func,
};

const mapDispatchToProps = {
  createCommission
};

export default connect(null, mapDispatchToProps)(InternalBrokerModal);
